import useCurrentUser from '~/hooks/useCurrentUser'

import { SignUpScenario } from '~/types/sign-up'

import { userHasAllRequiredFields } from '~/auth/utils/register.utils'

export function useSignupScenario(): {
  signUpScenario: SignUpScenario | undefined
  hidePasswordFields: boolean
  showRegisterForm: boolean
} {
  const user = useCurrentUser()
  const hasAllRequiredFields = userHasAllRequiredFields(user)

  let signUpScenario
  const isMissingFields = (user && !hasAllRequiredFields) || false

  return {
    signUpScenario,
    hidePasswordFields: isMissingFields,
    showRegisterForm: !user || isMissingFields,
  }
}
